import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  sub?: string;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  id?: string;
};
export function SectionHeading({
  eyebrow,
  title,
  sub,
  tone = 'light',
  align = 'center',
  id
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className={`max-w-[780px] ${align === 'center' ? 'mx-auto text-center' : ''}`} data-id="element-240" data-mp="3k18ag6cofsjo">
      {eyebrow && <p className={`mb-3 font-display text-[12px] font-extrabold tracking-[0.16em] ${dark ? 'text-sun' : 'text-coral-ink'}`} data-id="element-241" data-mp="bkvkz0aob30q">{eyebrow}</p>}
      <h2 id={id} className={`font-display text-[1.7rem] font-black uppercase leading-[1.1] tracking-tight sm:text-[2.2rem] md:text-[2.6rem] ${dark ? 'text-white' : 'text-brand'}`} data-id="element-242" data-mp="1utuy2yrfaj6">
        {title}
      </h2>
      {sub && <p className={`mt-4 text-[16px] leading-relaxed md:text-[17px] ${dark ? 'text-white/85' : 'text-ink/75'}`} data-id="element-243" data-mp="uifyjb7zmf61">{sub}</p>}
    </div>;
}